import { Record } from '../record/index.js';
import { Transactional } from '../transactions.js';
let _store = null;
export class Store extends Record {
    getStore() { return this; }
    get(name) {
        let local = this[name];
        if (local || this === this._defaultStore)
            return local;
        return this._owner ? this._owner.get(name) : this._defaultStore.get(name);
    }
    static get global() { return _store; }
    static set global(store) {
        if (_store) {
            _store.dispose();
        }
        Transactional.prototype._defaultStore = _store = store;
    }
}
Store.global = new Store();
//# sourceMappingURL=store.js.map